import React from "react"
import styled from "styled-components"

const SvgWrapper = styled.div<{ rotation?: number }>`
  display: flex;
  width: 304px; /* 부모 컨테이너 너비 */
  height: 0px; /* 높이를 0으로 설정 */
  flex-shrink: 0;

  /* 회전 효과 */
  transform: rotate(${(props) => props.rotation || 0}deg);

  svg {
    stroke-width: 3.5px;
    stroke: var(--base-gray30, #d1d1d1);
  }
`

const DashLineTwoToThree = ({ rotation = 0 }: { rotation?: number }) => {
  return (
    <SvgWrapper rotation={rotation}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="254"
        height="179"
        viewBox="0 0 254 179"
        fill="none"
      >
        <path
          d="M2.63379 176.755L251.656 2.38813"
          stroke="#D1D1D1"
          stroke-width="3.5"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-dasharray="7 14"
        />
      </svg>
    </SvgWrapper>
  )
}

export default DashLineTwoToThree
